import { ERentTime } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectRentalPeriodFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const RentalPeriodContainer: FC = () => {
  const { label, value, options } = useSelector(selectRentalPeriodFilter);

  const onChange = useFilterChangeCallback();

  const handleRentalPeriodChange = useCallback(
    (newValue: ERentTime) => {
      onChange({ action: 'setRentalPeriod', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleRentalPeriodChange} />
    </AdvancedFilterRow>
  );
};
